exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-modal-product-gallery__content[data-v-576a19e9]{position:relative;width:100%;max-width:100%;height:100%;min-height:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}\n", ""]);

// exports
